import { TextInput } from "@blasterjs/core";
import { debounce } from "lodash";
import React, { forwardRef, useState, useEffect, useCallback } from "react";

interface DebouncedTextInputProps {
  readonly onValueChange: (value: string) => void;
  readonly defaultValue: string;
  readonly placeholder?: string;
  readonly width?: string | number;
  readonly wait?: number;
}

const DEFAULT_WAIT = 1000;

const DebouncedTextInput = forwardRef<
  HTMLInputElement,
  DebouncedTextInputProps & Record<string, any>
>(({ onValueChange, wait, defaultValue, ...props }, ref) => {
  const [value, setValue] = useState(defaultValue);
  const debouncedOnValueChange = useCallback(debounce(onValueChange, wait || DEFAULT_WAIT), [
    onValueChange,
    wait
  ]);

  useEffect(() => {
    setValue(defaultValue);
    return () => {
      debouncedOnValueChange.cancel(); //see https://softwaremill.com/debounce-on-inputs-in-react/
    };
  }, [defaultValue]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    debouncedOnValueChange(newValue);
  };
  return <TextInput {...props} ref={ref} value={value} onChange={onChange} />;
});

export default DebouncedTextInput;
